import React, { useState } from "react";
import { Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import imageCompression from "browser-image-compression";
import '../style/chatbot_fields.css';

const Image_CheckboxOptions = ({ img,options, onSubmit, chat }) => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState([]);
  const toggleOption = (option) => {
    if (chat.answered) return;
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option)
        : [...prev, option]
    );
  };

  const handleSubmit = () => {
    if (selected.length === 0) return;
    onSubmit(selected.join(", "));
  };

  return (
    <div className="checkbox-options">
      {options.map((opt, idx) => (
        <label key={idx} className="checkbox-label">
          {/* <img src="" alt="" /> */}
          {/* <p>{img[idx]}</p> */}
          <input
            type="checkbox"
            value={img}
            checked={selected.includes(opt)}
            onChange={() => toggleOption(opt)}
          />
          <span className="label-text"> 
            <img src={img[idx]} alt="" />
             {opt}
            </span>
        </label>
      ))}
      <button className="chat-option-btn" onClick={handleSubmit} disabled={chat.answered}>
        {t('btn_submit')}
      </button>
    </div>
  );
};


const Image_CheckboxOptions_followup = ({ img,options, onSubmit, chat }) => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState([]);
  const toggleOption = (option) => {
    if (chat.answered) return;
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option)
        : [...prev, option]
    );
  };

  const handleSubmit = () => {
    if (selected.length === 0) return;
    onSubmit(selected);
  };

  return (
    <div className="checkbox-options">
      {options.map((opt, idx) => (
        <label key={idx} className="checkbox-label">
          {/* <img src="" alt="" /> */}
          {/* <p>{img[idx]}</p> */}
          <input
            type="checkbox"
            value={img}
            checked={selected.includes(opt)}
            onChange={() => toggleOption(opt)}
          />
          <span className="label-text"> 
            <img src={img[idx]} alt="" />
             {opt}
            </span>
        </label>
      ))}
      <button className="chat-option-btn" onClick={handleSubmit} disabled={chat.answered}>
        {t('btn_submit')}
      </button>
    </div>
  );
};



const Selectbox_image_options = ({ img,options, onSubmit, chat }) => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState([]);

  const toggleOption = (option) => {
    if (chat.answered) return;
    const updated = selected.includes(option)
    ? selected.filter((o) => o !== option)
    : [...selected, option];

    setSelected(updated);
  
    onSubmit(updated.join(", "));
  };

  const handleSubmit = () => {
    if (selected.length === 0) return;
    onSubmit(selected.join(", "));
  };

  return (
    <div className="checkbox-options">
      {options.map((opt, idx) => (
        <label key={idx} className="checkbox-label">
          {/* <img src="" alt="" /> */}
          {/* <p>{img[idx]}</p> */}
          <input
            type="checkbox"
            value={img}
            checked={selected.includes(opt)}
            onChange={() => toggleOption(opt)}
          />
          <span className="label-text"> 
            <img src={img[idx]} alt="" />
             {opt}
            </span>
        </label>
      ))}
    
    </div>
  );
};









const Selectboxoptions = ({ options, onSubmit, chat }) => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState([]);

  const toggleOption = (option) => {
    if (chat.answered) return;
  
    const updated = selected.includes(option)
      ? selected.filter((o) => o !== option)
      : [...selected, option];
  
    setSelected(updated);
  
    onSubmit(updated.join(", "));
  };

  const handleSelect = (option) => {
    if(chat.answered) return;

    setSelected(option);
    onSubmit(option);
};

  return ( 
    <div className="checkbox-options">
      {options.map((opt, idx) => (
        <label key={idx} className="checkbox-label">
          
          <input
            class="hide_radio_circles"
            type="radio"
            checked={selected.includes(opt)}
            onChange={() => toggleOption(opt)}
             
          />
          <span className="label-text"> 
             {opt}
            </span>
        </label>
      ))}
      
    </div>
  );
};



// const Selectboxoptions = ({ options, onSubmit, chat }) => {
//   const { t } = useLanguage();
//   const [selected, setSelected] = useState([]);

//   const toggleOption = (option) => {
//     if (chat.answered) return;
  
//     const updated = selected.includes(option)
//       ? selected.filter((o) => o !== option)
//       : [...selected, option];
  
//     setSelected(updated);
  
//     onSubmit(updated.join(", "));
//   };

//   const handleSubmit = () => {
//     if (selected.length === 0) return;
//     onSubmit(selected.join(", "));
//   };

//   return ( 
//     <div className="checkbox-options">
//       {options.map((opt, idx) => (
//         <label key={idx} className="checkbox-label">
          
//           <input
//             type="checkbox"
//             checked={selected.includes(opt)}
//             onChange={() => toggleOption(opt)}
             
//           />
//           <span className="label-text"> 
//              {opt}
//             </span>
//         </label>
//       ))}
      
//     </div>
//   );
// };



const CheckboxOptions = ({ options, onSubmit, chat }) => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState([]);
  const toggleOption = (option) => {
    if (chat.answered) return;
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option)
        : [...prev, option]
    );
  };

  const handleSubmit = () => {
    if (selected.length === 0) return;
    onSubmit(selected.join(", "));
  };

  return ( 
    <div className="checkbox-options">
      {options.map((opt, idx) => (
        <label key={idx} className="checkbox-label">
          
          <input
            type="checkbox"
            checked={selected.includes(opt)}
            onChange={() => toggleOption(opt)}
          />
          <span className="label-text"> 
             {opt}
            </span>
        </label>
      ))}
      <button className="chat-option-btn" onClick={handleSubmit} disabled={chat.answered}>
        {t('btn_submit')}
      </button>
    </div>
  );
};

const Chatsms = ({ chat, onOptionSelect,getAllAnswers  }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const isAnswered = chat.answered;
  return (
    <div
      className={`message ${chat.sender === "bot" ? "bot" : "user"}-message`}>
      {
        chat.sender === "bot" && chat.type === "yesno" && (
          <div className="yes-no-buttons">
            
            <button
              className="chat-option-btn"
              onClick={() => onOptionSelect("Yes")}
              disabled={chat.answered}
            >
              {t('btn_yes')}
            </button>
            <button
              className="chat-option-btn"
              onClick={() => onOptionSelect("No")}
              disabled={chat.answered}
            >
              {t('btn_no')}
            </button>

          </div>
        )



        
      }
      {/* result page */}
      {/* {
        chat.sender === "bot" && chat.type === "result" && (
          <div className="yes-no-buttons">
            <button
              className="chat-option-btn"
              onClick={() => {
                navigate("/result", { state: { answers: getAllAnswers } });
              }}
            >
              {t('btn_check_results')}
            </button>

          </div>
        )
      } */}
      
      {
        chat.sender === "bot" && chat.type === "result" && (
          <div className="yes-no-buttons">
            <button
              className="chat-option-btn"
              onClick={() => onOptionSelect("SHOW RESULT")}
            >
              {t('btn_check_results')}
            </button>
          </div>
        )
      }


      {chat.sender === "bot" && chat.type === "dateinput" && (
        <div className="yes-no-buttons" >
          <label htmlFor=""> To
            <input
              disabled={chat.answered}
              className="chat-date-btn"
              type="date"
              onChange={(e) => onOptionSelect(e.target.value)}
            />
          </label>
          <label htmlFor=""> From
            <input
              disabled={chat.answered}
              className="chat-date-btn"
              type="date"
              onChange={(e) => onOptionSelect(e.target.value)}
            />
          </label>
        </div>
      )}

      {chat.sender === "bot" && chat.type === "buttons" && (
        <div className="multi-buttons">
          {chat.options.map((opt, index) => (
            <button
              key={index}
              className="chat-option-btn"
              onClick={() => onOptionSelect(opt)}
              disabled={chat.answered}
            >
              {opt}
            </button>
          ))}
        </div>
      )}

      {chat.sender === "bot" && chat.type === "img_checkbox_followup" && (
        <Image_CheckboxOptions_followup
          img={chat.imgs}
          options={chat.options}
          onSubmit={onOptionSelect}
          chat={chat}
        />
      )}

      {chat.sender === "bot" && chat.type === "img_checkbox" && (
        <Image_CheckboxOptions
          img={chat.imgs}
          options={chat.options}
          onSubmit={onOptionSelect}
          chat={chat}
        />
      )}

      {chat.sender === "bot" && chat.type === "selectbox_img_checkbox" && (
        <Selectbox_image_options
          img={chat.imgs}
          options={chat.options}
          onSubmit={onOptionSelect}
          chat={chat}
        />
      )}
     {chat.sender === "bot" && chat.type === "selectbox" && (
        <Selectboxoptions
          options={chat.options}
          onSubmit={onOptionSelect}
          chat={chat}
        />
         
      )}
      {chat.sender === "bot" && chat.type === "checkbox" && (
        <CheckboxOptions
          options={chat.options}
          onSubmit={onOptionSelect}
          chat={chat}
        />
      )}

      {chat.sender === "bot" && chat.type === "file" && (
        <div className="file-upload-bubble">
          <label className={`chat-option-btn ${chat.answered ? "disabled" : ""}`}>
            {chat.answered ? t('msg_file_selected') : t('msg_choose_file')}
            <input
              type="file"
              style={{ display: "none" }}
              disabled={chat.answered}
              onChange={(e) => {
                if (e.target.files.length > 0) {
                  onOptionSelect(e.target.files[0].name);
                }
              }}
            />
          </label>
        </div>
      )}

      {chat.sender === "bot" && chat.type === "image" && (
        <div className="image-upload-bubble">
          <label className={`chat-option-btn ${chat.answered ? "disabled" : ""}`}>
            {chat.answered ? t('msg_image_selected') : t('msg_choose_image')}
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              disabled={chat.answered}
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0) {
                  const file = e.target.files[0];
                  const formData = new FormData();
                  formData.append("image", file);
                  
                  fetch("/api/upload", {
                    method: "POST",
                    body: formData
                  })
                    .then(res => res.json())
                    .then(data => {
                      onOptionSelect(data.path); // saved image path
                    });
                }
              }}
            />
          </label>
        </div>
      )}
      {chat.sender === "bot" && chat.type === "camera" && (
        <div className="yes-no-buttons">

          <div className="image-upload-bubble">
            <label className={`chat-option-btn ${chat.answered ? "disabled" : ""}`}>
              {chat.answered ? t('msg_image_selected') : t('msg_add_image')}
              <input
                type="file"
                accept="image/*"
                capture="user"
                style={{ display: "none" }}
                disabled={chat.answered}
                onChange={async (e) => {
                  if (e.target.files && e.target.files.length > 0) {
                    const file = e.target.files[0];
                    const options = {
                      maxSizeMB: 1,
                      maxWidthOrHeight: 1280,
                      useWebWorker: true
                    };


                    try {
                      const compressedFile = await imageCompression(file, options);
                
                      const formData = new FormData();
                      formData.append("image", compressedFile);
                
                      fetch("/api/upload", {
                        method: "POST",
                        body: formData
                      })
                      .then(res => res.json())
                      .then(data => {
                        onOptionSelect(data.path);
                      });
                
                    } catch (error) {
                      console.error(error);
                    }
                    // const formData = new FormData();
                    // formData.append("image", file);
                    
                    // fetch("/api/upload", {
                    //   method: "POST",
                    //   body: formData
                    // })
                    //   .then(res => res.json())
                    //   .then(data => {
                    //     onOptionSelect(data.path);
                    //   })
                    //   .catch(err => console.error(err));
                  }
                }}
              />
            </label>
          </div>
        </div>
      )}
<Typography variant="body1" className="message-text">
  {typeof chat.text === "string" && chat.text.startsWith("/images") ? (
    <img
      src={chat.text}
      alt="uploaded"
      className="uploaded-image"
    />
  ) : (
    typeof chat.text === "string" ? chat.text : ""
  )}
</Typography>




    </div>
  );



};




export default Chatsms;